import React, { useEffect } from 'react';
import { autoId } from '@workday/upc-common';
import { useTranslation } from 'react-i18next';
import { LoadingDots } from '@workday/canvas-kit-react';
import { ID_ONBOARDING_LOCALE_SELECT } from '../../../autoIds';
import { useEnrollmentLocaleMutation, useGetInvitationQuery } from '../../../slices/auth-api.slice';
import { useGetAvailableLocalesQuery } from '../../../slices/account-api.slice';
import { FormField } from '@workday/canvas-kit-react/form-field';
import styles from './registration-language-select.module.scss';
import { Select as PreviewSelect } from '@workday/canvas-kit-preview-react/select';
import { localeOptions } from '../../../shared/locale-selector/localeUtils';
import { RenderSelected } from '../../../shared/locale-selector/render-selected';
import { RenderOption } from '../../../shared/locale-selector/render-option';
import { updateLocale } from '../../../../i18n';

export function RegistrationLanguageSelect() {
    const { t } = useTranslation('auth');

    const [selectedLocale, setSelectedLocale] = React.useState('');

    // @ts-ignore
    const { data, isLoading } = useGetAvailableLocalesQuery();
    const { data: invitation, isLoading: isInvitationLoading } = useGetInvitationQuery();
    const [updateOnboardingLocale, { data: updatedLocale, isSuccess }] = useEnrollmentLocaleMutation();

    useEffect(() => {
        if (updatedLocale && isSuccess) {
            setSelectedLocale(updatedLocale?.locale.toLowerCase());
            updateLocale(updatedLocale?.locale);
        }
    }, [updatedLocale, isSuccess]);

    useEffect(() => {
        if (invitation?.locale) {
            setSelectedLocale(invitation.locale.toLowerCase());
            updateLocale(invitation.locale);
        }
    }, [invitation, isInvitationLoading]);

    const selectLanguage = t('OnboardingLocalePreferences.selectLanguage');
    const locales = localeOptions(selectLanguage, data);
    const onChange = event => {
        const selectedLocale = locales.filter(v => v.value === event.target.value)[0];
        setSelectedLocale(selectedLocale.value);
        updateOnboardingLocale({ locale: selectedLocale.value });
    };

    return (
        <div>
            {isLoading || isInvitationLoading ? (
                <LoadingDots {...autoId('loadingDots')} />
            ) : (
                <FormField className={styles.registrationLanguageSelect}>
                    <PreviewSelect
                        {...autoId(ID_ONBOARDING_LOCALE_SELECT)}
                        onChange={onChange}
                        value={selectedLocale}
                        options={locales}
                        renderOption={RenderOption}
                        renderSelected={RenderSelected}
                    />
                </FormField>
            )}
        </div>
    );
}
